import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import AppBar from '@material-ui/core/AppBar';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';


import AddIcon from '@material-ui/icons/Add';

import amber from '@material-ui/core/colors/amber';
import indigo from '@material-ui/core/colors/indigo';

import * as routes from 'constants/routes';
import { startAddInvoice } from '../../../store/actions/invoices';
import { startEditAdmin } from '../../../store/actions/admin';
import { startRemoveProject } from '../../../store/actions/projects';

import { ActionButton } from './Actions';
import { InvoiceCards } from '../Invoices';
import { ReceiptsCards, ReceiptDialog2 } from '../Receipts';
import { TimecardsCards, TimecardDialog } from '../Timecards';
import { DetailCards, JobTaskCards } from './Detail';
import { FileDialog, NoteDialog, PhotoDialog, TaskDialog } from './Dialog';
import { JobNoteCards } from './Notes';
import { JobFileCards } from './Files';
import { JobPhotoCards } from './Photos';
import { ConfirmDialog } from 'components/admin/Dialogs';

import {
  QuoteDialog,
} from '../Dialogs';
import {
  setQuoteForm,
} from '../../../store/actions';
import {
  helpDispatch,
  Tooltip,
  TooltipTypes
} from 'components/admin/Help';

const styles = theme => ({
  root: {
    flexGrow: 1,
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  actions: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
  },
  addButton: {
    backgroundColor: amber[500],
    color: "#fff",
    position: 'relative',
    left: '-300px',
    top: '35px',
  },
  deleteButton: {
    alignSelf: "center",
    marginRight: theme.spacing.unit*2,
  },
  closeButton: {
    alignSelf: "center",
    marginRight: theme.spacing.unit*2,
  },
  avatar: {
    margin: theme.spacing.unit,
    color: '#fff',
    backgroundColor: indigo[100],
  },
  margin: {
    marginLeft: theme.spacing.unit*2,
    marginRight: theme.spacing.unit*2,
  },
  card: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingTop: theme.spacing.unit*2,
    paddingBottom: theme.spacing.unit*2,
    paddingRight: theme.spacing.unit*5,
    paddingLeft: theme.spacing.unit*2,
  },
  client: {
    minWidth: '100px',
  },
  elevate: {
    zIndex: theme.zIndex.tooltipAction,
    position: 'relative',
    backgroundColor: '#fff',
    borderRadius: '5px',
  },
});

function TabContainer(props) {
  return (
    <Typography component="div" style={{ padding: 8 * 3 }}>
      {props.children}
    </Typography>
  );
}

TabContainer.propTypes = {
  children: PropTypes.node.isRequired,
};


class JobDetail extends Component {
  constructor(props){
    super(props);
    this.state = {
      selectedTab: "details",
      dialogType: undefined,
      receipt: undefined,
      receiptType: undefined,
      invoice: undefined,
      timecard: undefined,
      timecardType: undefined,
      task: undefined,
      showTaskDialog: false,
      taskDialogType: undefined,
      note: undefined,
      showNoteDialog: false,
      noteDialogType: undefined,
      file: undefined,
      showFileDialog: false,
      fileDialogType: undefined,
      photo: undefined,
      showPhotoDialog: false,
      photoDialogType: undefined,
      showDelete: false,
    }
  }

  handleCancelDelete = () => {
    this.setState({ showDelete: false });
  }

  handleDelete = () => {
    const {
      project,
      startEditAdmin,
      startRemoveProject,
    } = this.props;

    startRemoveProject(project.id);
    startEditAdmin({ project: null });
    this.setState({ showDelete: false });
  }

  handleChange = (event, selectedTab) => {
    this.setState({ selectedTab });
  };

  handleClick = event => {
      this.setState({ anchorEl: event.currentTarget });
    };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };

  render() {
    const {
      history,
      classes,
      client,
      project,
      projectTasks,
      projectValidation,
      startAddInvoice,
      startEditAdmin,
      setQuoteForm,
      help
    } = this.props;
    const {
      anchorEl,
      selectedTab,
      receipt,
      receiptType,
      timecard,
      timecardType,
      task,
      showTaskDialog,
      taskDialogType,
      note,
      showNoteDialog,
      noteDialogType,
      file,
      showFileDialog,
      fileDialogType,
      photo,
      showPhotoDialog,
      photoDialogType,
      dialogType,
      showDelete,
    } = this.state;

    console.log("STATE:", this.state);
    return (
      <div className={classes.root}>
        <ConfirmDialog
          open={showDelete}
          title="Delete Job"
          contentText="This action will delete the job. Proceed?"
          handleCancel={this.handleCancelDelete}
          handleOk={this.handleDelete}
        />
        {dialogType === "quote" &&
          <QuoteDialog
            show={true}
            handleClose={() => this.setState({ dialogType: undefined })}
          />
        }
        {receipt &&
          <ReceiptDialog2
            show={true}
            type={receiptType}
            receiptData={receipt}
            handleClose={() => this.setState({receipt: undefined})}
          />
        }
        {timecard &&
          <TimecardDialog
            show={true}
            type={timecardType}
            timecardData={timecard}
            handleClose={() => this.setState({timecard: undefined})}
          />
        }
        {task &&
          <TaskDialog
            project={project}
            show={showTaskDialog}
            type={taskDialogType}
            taskData={task}
            handleClose={() => {
              this.setState({
                showTaskDialog: false,
                taskDialogType: undefined,
                task: undefined,
              });
            }}
          />
        }
        {note &&
          <NoteDialog
            project={project}
            show={showNoteDialog}
            type={noteDialogType}
            note={note}
            handleClose={() => {
              this.setState({
                showNoteDialog: false,
                noteDialogType: undefined,
                note: undefined,
              });
            }}
          />
        }
        {file &&
          <FileDialog
            project={project}
            show={showFileDialog}
            type={fileDialogType}
            file={file}
            handleClose={() => {
              this.setState({
                showFileDialog: false,
                fileDialogType: undefined,
                file: undefined,
              });
            }}
          />
        }
        {photo &&
          <PhotoDialog
            project={project}
            show={showPhotoDialog}
            type={photoDialogType}
            file={photo}
            handleClose={() => {
              this.setState({
                showPhotoDialog: false,
                photoDialogType: undefined,
                photo: undefined,
              });
            }}
          />
        }
        <Card className={classes.card}>
          <div className={classes.row}>
            <Avatar className={classNames(classes.avatar, classes.margin)}>
              J
            </Avatar>
            <div className={classes.client}>
              {client &&
                <Typography variant="subheading">
                  {client.fullName}
                </Typography>
              }
              {project &&
                <Typography variant="caption">
                  {project.jobCode}
                </Typography>
              }
            </div>
          </div>
          <div className={classes.actions}>
            <div className={classes.deleteButton}>
              <Button
                color="primary"
                variant="raised"
                onClick={() => this.setState({ showDelete: true })}
              >
                Delete
              </Button>
            </div>
            <div className={classes.closeButton}>
              <Button
                color="primary"
                variant="raised"
                onClick={() => {
                  if (projectValidation.isInvalid) {
                    startEditAdmin({ project: { ...project, showValidation: true }});
                  } else {
                    startEditAdmin({ project: null });
                  }
                }}
              >
                Close
              </Button>
            </div>
            <ActionButton
              project={project}
              type={selectedTab}
              handleAdd={(action) => {
                console.log("action:", action);
                if (action.task !== undefined) {
                  if (action.task.type === "quote") {
                    setQuoteForm({ projectId: project.id });
                    this.setState({ dialogType: "quote" })
                  } else {
                    this.setState({
                      showTaskDialog: true,
                      taskDialogType: "add",
                      task: action.task,
                    });
                  }
                } else if (action.note !== undefined) {
                  this.setState({
                    showNoteDialog: true,
                    noteDialogType: "add",
                    note: action.note,
                  })
                } else if (action.file !== undefined) {
                  this.setState({
                    showFileDialog: true,
                    fileDialogType: "add",
                    file: action.file,
                  })
                } else if (action.photo !== undefined) {
                  this.setState({
                    showPhotoDialog: true,
                    photoDialogType: "add",
                    photo: action.photo,
                  })
                } else if (action.invoice !== undefined) {
                  startAddInvoice({
                    projectId: action.invoice.projectId,
                    clientId: action.invoice.clientId,
                  })
                    .then(result => startEditAdmin({ invoice: result }))
                    .then(() => {
                      history.push(routes.INVOICES);
                    });
                } else if (action.timecard !== undefined) {
                  this.setState({
                    timecard: {
                      projectId: action.timecard.projectId,
                      clientId: action.timecard.clientId,
                    },
                    timecardType: "add"
                  });
                } else if (action.receipt !== undefined) {
                  this.setState({
                    receipt: {
                      projectId: action.receipt.projectId,
                      clientId: action.receipt.clientId,
                    },
                    receiptType: "add"
                  });
                }
              }}
            />
          </div>
        </Card>
        <AppBar position="static" color="default">
          <Tabs
            value={selectedTab}
            onChange={this.handleChange}
            indicatorColor="primary"
            textColor="primary"
            scrollable
            scrollButtons="auto"
          >
            <Tab label="Details" value="details"/>
            <Tab
              label="Tasks"
              value="tasks"
            />
            {/*<Tab label="Files" value="files"/>*/}
            <Tab label="Invoices" value="invoices"/>
            <Tab label="Time" value="timecards"/>
            <Tooltip type={TooltipTypes.job.TABS} placement="top">
              <div />
            </Tooltip>
            <Tab label="Receipts" value="receipts"/>
            {/*<Tab label="Notes" value="notes"/>*/}
            {/*<Tab label="Photos" value="photos"/>*/}
          </Tabs>
        </AppBar>
        {selectedTab === "details" &&
          <TabContainer>
            <DetailCards project={project} />
          </TabContainer>
        }
        {selectedTab === "tasks" &&
          <TabContainer>
            <JobTaskCards
              project={project}
              handleEdit={(task) => {
                console.log("task:", task);
                if (task.type === "quote") {
                  setQuoteForm(task);
                  this.setState({ dialogType: "quote" })
                } else {
                  this.setState({
                    showTaskDialog: true,
                    taskDialogType: "edit",
                    task: task
                  });
                }
              }}
            />
          </TabContainer>
        }
        {selectedTab === "files" &&
          <TabContainer>
            <JobFileCards
              project={project}
              handleEdit={() => {
                console.log("handleedit")
              }}
            />
          </TabContainer>
        }
        {selectedTab === "invoices" &&
          <TabContainer>
            <InvoiceCards project={project} />
          </TabContainer>
        }
        {selectedTab === "timecards" &&
          <TabContainer>
            <TimecardsCards
              project={project}
              handleEdit={(timecard) => {
                this.setState({
                  timecard: timecard,
                  timecardType: "edit",
                })}
              }/>
          </TabContainer>
        }
        {selectedTab === "receipts" &&
          <TabContainer>
            <ReceiptsCards
              project={project}
              handleEdit={(receipt) => {
                this.setState({
                  receipt: receipt,
                  receiptType: "edit",
                })}
              }/>
          </TabContainer>
        }
        {selectedTab === "notes" &&
          <TabContainer>
            <JobNoteCards
              project={project}
              handleEdit={(note) => {
                console.log("note:", note);
                this.setState({
                  showNoteDialog: true,
                  noteDialogType: "edit",
                  note: note
                })
              }}
            />
          </TabContainer>
        }
        {selectedTab === "photos" &&
          <TabContainer>
            <JobPhotoCards
              project={project}
              handleEdit={() => {
                console.log("handleedit")
              }}
            />
          </TabContainer>
        }
      </div>
    );
  }
}

JobDetail.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => {
  const project = state.projectsState.find(project => project.id === state.adminState.project.id);
  const client = project.clientId === undefined
    ? undefined
    : state.clientsState.find(client => client.id === project.clientId);
  const projectTasks = state.projectTasksState.filter( projectTask => projectTask.projectId === project.id);

  const projectValidation = state.validation.projects.find(item => item.id === project.id);

  return({
    project,
    client,
    projectTasks,
    projectValidation,
    help: state.help,
  });
};

const mapDispatchToProps = {
  startAddInvoice,
  startEditAdmin,
  startRemoveProject,
  setQuoteForm,
}

export default compose(
  withStyles(styles),
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(JobDetail);



// WEBPACK FOOTER //
// ./src/components/admin/Jobs/JobDetail.jsx